<ng-container *ngIf="data.pageType == 'dashboard' || data.pageType == 'plans' || data.pageType == 'jiotvplans'">
    <div style="white-space: pre">
        {{ displayData }}
    </div>
</ng-container>

<ng-container *ngIf="data.pageType == 'deeplink'">
    <div>
        {{ displayData }}
    </div>
</ng-container>
<ng-container *ngIf="data.pageType == 'uitemplate'">
    <div style="white-space: pre">
        {{ displayData }}
    </div>
</ng-container>
<ng-container *ngIf="displayDataObject?.pageType === 'audit'">
    <div style="white-space: pre" [innerHTML]="highlightedDisplayData"></div>
</ng-container>

<ng-container *ngIf="data.pageType === 'scheduleItems'">
    <div style="margin-top: 10px">
        <app-table tableName="MULTISCHEDULE_LIST_MODAL"></app-table>
    </div>
    <div *ngIf="displayData === '24x7' || parsedDisplayData == '24x7'; else parsedTable">
        <div class="schedule-row" style="padding-left: 40px">24x7</div>
    </div>
    <ng-template #parsedTable>
        <div *ngFor="let schedule of parsedDisplayData" class="schedule-row">
            <!-- Start Date -->
            <div class="schedule-cell">
                <span>{{ schedule.startdate }}</span>
            </div>
            <!-- Start Time -->
            <div class="schedule-cell">
                <span>{{ schedule.starttime }}</span>
            </div>
            <!-- End Date -->
            <div class="schedule-cell">
                <span>{{ schedule.enddate }}</span>
            </div>
            <!-- End Time -->
            <div class="schedule-cell">
                <span>{{ schedule.endtime }}</span>
            </div>
        </div>
    </ng-template>
</ng-container>
<ng-container *ngIf="data.pageType === 'multiSchedule'">
    <div style="margin-top: 10px">
        <app-table tableName="MULTISCHEDULE_LIST_MODAL"></app-table>
    </div>
    <div *ngIf="parsedDisplayData == '24x7'; else multiTable">
        <div class="schedule-row" style="padding-left: 40px">24x7</div>
    </div>
    <ng-template #multiTable>
        <div *ngFor="let schedule of parsedDisplayData" class="schedule-row">
            <div class="schedule-cell">
                <span>{{ schedule.startdate }}</span>
            </div>
            <div class="schedule-cell">
                <span>{{ schedule.starttime }}</span>
            </div>
            <div class="schedule-cell">
                <span>{{ schedule.enddate }}</span>
            </div>
            <div class="schedule-cell">
                <span>{{ schedule.endtime }}</span>
            </div>
        </div>
    </ng-template>
</ng-container>
